import { FC } from 'react'
import IconSwitch from 'assets/switch.svg?react'
import { ButtonIcon } from 'components/extend/ButtonIcon'

import { OrderFilterSearchField } from './OrderFilterSearchField'

import s from './OrderFilterSearchField/OrderFilterSearchField.module.less'

export interface OrderFilterSearchFieldsProps {
  departure: string
  destination: string
  onSetDeparture: (value: string) => void
  onSetDestination: (value: string) => void
  onSwapPoints: () => void
}

export const OrderFilterSearchFields: FC<OrderFilterSearchFieldsProps> = ({
  departure,
  destination,
  onSetDeparture,
  onSetDestination,
  onSwapPoints
}) => (
  <>
    <OrderFilterSearchField
      onChange={onSetDeparture}
      postfix={<ButtonIcon className={s.iconSwitch} icon={IconSwitch} onClick={onSwapPoints} size="xs" />}
      type="departure"
      value={departure}
    />
    <OrderFilterSearchField onChange={onSetDestination} type="destination" value={destination} />
  </>
)
